import React from 'react'

export const DownArrowIcon = () => (
  <svg className="pulse" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 15L20 25L10 15" stroke="black" strokeWidth="3" />
  </svg>
)
